import postPinIntelView from './postPinIntelComponent.html';
import './postPinIntelComponent.css';
import { AssetManager } from 'components/sharpr/assetManager/AssetManager.js';
import { ensure } from 'components/sharpr/ensure/ensure';
import moment from 'moment';

export function postPinIntelComponent() {
	return {
		bindings: {
			post: '=',
		},
		controllerAs: 'vm',
		controller: postPinIntelComponentCtrl,
		template: postPinIntelView,
	};
}

export class postPinIntelComponentCtrl {
	constructor($scope, Cfg, Api, modal, FineTunePosts) {
		'ngInject';
		this.$scope = $scope;
		this.Cfg = Cfg;
		this.Api = Api;
		this.modal = modal;
		this.FineTunePosts = FineTunePosts;
	}

	$onInit() {
		this.hasApprovalWorkflow = this.Cfg.read('Features.post_approval') == 1;
		AssetManager.loadBubbleCss(this.post);
		this.$scope.$watch('vm.post', () => this.$onChanges({ post: true }));
	}

	$onChanges(changes) {
		if (changes.post && this.Cfg.read('Features.visual_tags') == 1) {
			this.post.hasVisualTags = ensure.array(this.post.tags).some(tag => tag.is_visual);
		}
	}

	addInsight() {
		const options = {
			heading: 'Enter your insight',
			text: this.post.headline,
		};
		this.modal.prompt(options).then(
			intel_text => {
				this.post.intel_text = intel_text;
				if (this.post.id > 0) {
					// post id is negative if file is uploading
					this.Api.patch(`/posts/${this.post.id}`, { intel_text });
				}
			},
			() => {}
		);
	}

	cancelFileUpload() {
		this.post.deleted_at = moment().format();
		this.post.file.cancel();
	}

	deleteErroredPost() {
		// sometimes we delete posts that aren't yet created in the db,
		// so we just need to make sure it doesn't show in the UI
		this.post.deleted_at = moment().format();
		if (this.post.id > -1) {
			this.Api.delete(`/posts/${this.post.id}`);
		}
	}
}
